import type { IAdViewPremium } from "@finn-no/adview-provider-frontend-types";
import { Trans, useLingui } from "@lingui/react";

type Props = {
  premium: IAdViewPremium;
};
const Premium = ({ premium }: Props) => {
  const { i18n } = useLingui();

  const premiumUrlInfo = i18n._({
    id: "itemPageLayout.safetyElement.premium.premiumUrlInfo",
    message: "This car is part of the used car program {name}",
    comment: "Used as text in a link, that takes the user to more info about the specific premium program for the car",
    values: {
      name: premium?.name,
    },
  });

  return (
    <>
      <p className="mb-0">
        <a href={premium.url}>{premiumUrlInfo}</a>
      </p>
      <p className="mb-0 mt-16 md:mt-8">
        <Trans
          id="itemPageLayout.safetyElement.premium.generalPremiumInfo"
          message="A used car program is defined by the individual importer of the car brand, and the cars are carefully selected and undergo
				even more extensive tests than what is standard. Program cars can only be purchased from authorized brand dealers."
        />
      </p>

      {premium.help_center_url && (
        <p className="mb-0 mt-16 md:mt-8">
          <a href={premium.help_center_url} target="_blank" rel="noopener">
            <Trans
              id="itemPageLayout.safetyElement.premium.readMore"
              message="More about program cars on FINN's help center."
            />
          </a>
        </p>
      )}
    </>
  );
};

export default Premium;
